// Major U.S. metro markets for the Choose Your Market selector.
// Used on the landing hero and as the directory market filter.
// "All Markets" is the implicit default (empty string).

export const MARKETS = [
  { value: "DFW", label: "Dallas–Fort Worth, TX", cityMatch: "Dallas|Fort Worth|Plano|Frisco|McKinney|Irving|Arlington|Richardson|Garland|Denton|Carrollton|Lewisville|Allen|Rockwall|Grapevine|Southlake|Flower Mound|Mesquite|Grand Prairie|Mansfield|Rowlett|Cedar Hill|Wylie", primaryCity: "Dallas" },
  { value: "Houston", label: "Houston, TX", primaryCity: "Houston" },
  { value: "New York", label: "New York, NY", primaryCity: "New York" },
  { value: "Los Angeles", label: "Los Angeles, CA", primaryCity: "Los Angeles" },
  { value: "Chicago", label: "Chicago, IL", primaryCity: "Chicago" },
  { value: "Atlanta", label: "Atlanta, GA", primaryCity: "Atlanta" },
  { value: "Miami", label: "Miami, FL", primaryCity: "Miami" },
  { value: "Phoenix", label: "Phoenix, AZ", primaryCity: "Phoenix" },
  { value: "Denver", label: "Denver, CO", primaryCity: "Denver" },
  { value: "Seattle", label: "Seattle, WA", primaryCity: "Seattle" },
];

// Local storage key so the visitor's selection persists across pages.
export const MARKET_STORAGE_KEY = "ic_selected_market";

export const getStoredMarket = () => {
  try {
    return localStorage.getItem(MARKET_STORAGE_KEY) || "";
  } catch {
    return "";
  }
};

export const setStoredMarket = (value) => {
  try {
    if (value) localStorage.setItem(MARKET_STORAGE_KEY, value);
    else localStorage.removeItem(MARKET_STORAGE_KEY);
  } catch {
    // localStorage unavailable — ignore
  }
};
